import { useContext, useEffect, useState } from 'react';
import './styles.css';
import UserContext from 'contexts/UserContext';

function BuyNow({ promo = null }) {
    const { currentUser, currentPromo } = useContext(UserContext);
    const [promotion, setPromotion] = useState({joined: false, title: '', path:'' });

    useEffect(() => {
        if (promo) {
            setPromotion({
                joined: promo.status === 'joined',
                title: promo.title,
                path: promo.path
            });
            return;
        }

        if (currentUser) {
            setPromotion({
                joined: currentUser.PromoAtiva,
                title: currentPromo.titulo,
                path: currentPromo.path
            });
            return;
        }
    }, [promo, currentPromo, currentUser])

    return (
        <div className="buy-now-container">
            {promotion.joined ? (
                <>
                    <p className="buy-now-text">
                        Faça uma compra agora pelo Juntos+ e comece a acumular números da sorte para concorrer a prêmios toda semana!
                    </p>
                    <div className="buy-now-cta-container">
                        <a
                            className="buy-now-cta"
                            href={`https://onelink.to/${promotion.path}?utm_source=tobypromo&utm_medium=button`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Compre agora
                        </a>
                    </div>
                </>
            ) : (
                <p className="buy-now-text">
                    Falta <b>MUITO POUCO</b> pra você participar da nossa nova promoção! Clique no botão acima e ative o seu cadastro na <b>{promotion.title}</b>
                </p>
            )}
        </div>
    );
}

export default BuyNow;
